import type { FC } from 'react'
import { useEffect } from 'react'

import { Translation } from '@/components/i18n/Translation'
import { DispatchTabs } from '@/components/util/Tabs'
import { useSearchParamsByKey } from '@/hooks/searchParams'
import { numberFormat } from '@/util/formatters/numbers'

import { INJURY_REPORT_STATUS_IDS } from '../constants'
import { getInjuryReportStatusTextId } from '../helpers'
import { useInjuryReportsList } from '../hooks'
import { useInjuryReportsContext } from '../index.context'

import './StatusTabs.styles.scss'

const StatusTabs: FC<{ sortedStatuses: number[]; isLoading: boolean }> = ({
  sortedStatuses,
  isLoading,
}) => {
  const { statusFilter, setStatusFilter } = useInjuryReportsContext()
  const { statusCounter } = useInjuryReportsList()

  const [queryStatus, setQueryStatus] = useSearchParamsByKey('status')

  useEffect(() => {
    setStatusFilter(Number(queryStatus) || INJURY_REPORT_STATUS_IDS.OPEN)
  }, [queryStatus])

  const tabs = sortedStatuses.map(statusId => ({
    selected: statusFilter === statusId,
    children: (
      <>
        <Translation id={getInjuryReportStatusTextId(statusId)} />{' '}
        <b>{numberFormat(statusCounter[statusId])}</b>
      </>
    ),
    onClick: () => {
      setStatusFilter(statusId)
      setQueryStatus(statusId)
    },
  }))

  return <DispatchTabs className="status-tabs" tabs={tabs} isLoading={isLoading} />
}

export default StatusTabs
